import { useEffect, useState } from "react";

const AdminTexts = () => {

  const [hashtags, setHashtags] = useState({
    am: {},
    ru: {},
    en: {},
  });

  const [openEditor, setOpenEditor] = useState(null);
  const [statusMessage, setStatusMessage] = useState(""); // Для уведомления

  const hashtagKeys = ["hashtag1", "hashtag2", "hashtag3", "hashtag4", "hashtag5"];

  // Загрузка данных из JSON
  useEffect(() => {
    const load = async () => {
      try {
        const [am, ru, en] = await Promise.all([
          fetch("/locales/am.json").then((r) => r.json()),
          fetch("/locales/ru.json").then((r) => r.json()),
          fetch("/locales/en.json").then((r) => r.json()),
        ]);

        setHashtags({
          am: am.hashtags || {},
          ru: ru.hashtags || {},
          en: en.hashtags || {},
        });
      } catch (err) {
        console.error("Ошибка загрузки JSON:", err);
      }
    };

    load();
  }, []);

  const save = async (key, data) => {
    try {
      const res = await fetch("/api/update_locales.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key, values: data }),
      });

      const json = await res.json();

      if (json.status === "success") {
        setStatusMessage("Պահպանված է");
      } else {
        setStatusMessage("Սխալ: " + json.message);
      }
    } catch (err) {
      setStatusMessage("Կապի խափանում: " + err.message);
    }

    // Очистить уведомление через 3 секунды
    setTimeout(() => setStatusMessage(""), 3000);
  };

  // РЕНДЕР БЛОКА aboutus / privacy
  const renderSimpleBlock = (state, setState, key, label) => (
    <div className="w-full bg-black/20 p-4 sm:p-5 border rounded mt-4 sm:mt-5">
      <h3 className="text-xl sm:text-2xl mb-3 sm:mb-4">{label}</h3>

      {["am", "ru", "en"].map((lang) => (
        <div key={lang} className="mb-3 sm:mb-4">
          <label className="text-sm sm:text-base block mb-1">{lang.toUpperCase()}</label>
          <input
            type="text"
            className="w-full p-2 text-black rounded text-sm sm:text-base"
            value={state[lang]}
            onChange={(e) => setState({ ...state, [lang]: e.target.value })}
          />
        </div>
      ))}

      <button
        type="button"
        className="bg-[#006674] px-4 sm:px-6 py-2 rounded text-sm sm:text-base hover:bg-[#004d58] transition-colors"
        onClick={() => save(key, state)}
      >
        Պահպանել
      </button>

      {statusMessage && (
        <p className="mt-2 text-green-400 text-sm sm:text-base">{statusMessage}</p>
      )}
    </div>
  );

  // РЕНДЕР ХЕШТЕГОВ
  const renderHashtags = () => (
    <div className="w-full bg-black/20 p-4 sm:p-5 border rounded mt-4 sm:mt-5 text-white">
      <h3 className="text-xl sm:text-2xl mb-3 sm:mb-4">Hashtags</h3>

      {/* Десктоп: три колонки */}
      <div className="hidden md:grid md:grid-cols-3 gap-4 sm:gap-6">
        {["am", "ru", "en"].map((lang) => (
          <div key={lang}>
            <h4 className="text-lg sm:text-xl mb-2 sm:mb-3">{lang.toUpperCase()}</h4>

            {hashtagKeys.map((keyName) => (
              <div key={keyName} className="mb-2 sm:mb-3">
                <label className="text-xs sm:text-sm block mb-1">{keyName}</label>
                <input
                  type="text"
                  className="w-full p-2 text-black rounded text-sm"
                  value={hashtags[lang][keyName] || ""}
                  onChange={(e) =>
                    setHashtags({
                      ...hashtags,
                      [lang]: {
                        ...hashtags[lang],
                        [keyName]: e.target.value,
                      },
                    })
                  }
                />
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Мобильные: табы */}
      <div className="md:hidden">
        <div className="flex gap-2 mb-4">
          {["am", "ru", "en"].map((lang) => (
            <button
              key={lang}
              onClick={() => setOpenEditor(openEditor === lang ? null : lang)}
              className={`flex-1 py-2 px-3 rounded text-sm font-medium transition-colors ${
                openEditor === lang
                  ? "bg-[#006674] text-white"
                  : "bg-white/10 text-white hover:bg-white/20"
              }`}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>

        {openEditor && (
          <div className="space-y-3">
            {hashtagKeys.map((keyName) => (
              <div key={keyName}>
                <label className="text-xs block mb-1">{keyName}</label>
                <input
                  type="text"
                  className="w-full p-2 text-black rounded text-sm"
                  value={hashtags[openEditor][keyName] || ""}
                  onChange={(e) =>
                    setHashtags({
                      ...hashtags,
                      [openEditor]: {
                        ...hashtags[openEditor],
                        [keyName]: e.target.value,
                      },
                    })
                  }
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <button
        type="button"
        className="bg-[#006674] px-4 sm:px-6 py-2 rounded text-sm sm:text-base hover:bg-[#004d58] transition-colors mt-4 sm:mt-6"
        onClick={() => save("hashtags", hashtags)}
      >
        Պահպանել
      </button>

      {statusMessage && (
        <p className="mt-2 text-green-400 text-sm sm:text-base">{statusMessage}</p>
      )}
    </div>
  );

  return (
    <div className="p-3 sm:p-4 md:p-5 text-white">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-5">
        Տեքստերի փոփոխություն
      </h2>

      <div className="mt-4 sm:mt-6">
        <h1 className="text-lg sm:text-xl font-bold mb-4 sm:mb-5">Հաճախ փնտրում են</h1>
      </div>
      {renderHashtags()}
    </div>
  );
};

export default AdminTexts;